import { render, staticRenderFns } from "./FeePayItem.vue?vue&type=template&id=940d1b46&scoped=true&"
import script from "./FeePayItem.vue?vue&type=script&lang=js&"
export * from "./FeePayItem.vue?vue&type=script&lang=js&"
import style0 from "./FeePayItem.vue?vue&type=style&index=0&id=940d1b46&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940d1b46",
  null
  
)

export default component.exports